import Minder from '../minder/minder.json';
import { createFlow } from './flow';

export const getMinderAndFlowJsonByPathname = (pathname, userType, isRegisteredShopper) => {
  const flow = {
    flowJson: createFlow(pathname, userType, isRegisteredShopper),
    minderJson: Minder,
  };

  return flow;
};
